





















import {Component, Vue, Watch} from 'vue-property-decorator';
import Password from '../components/Password.vue';
import ErrorGroup from '../components/ErrorGroup.vue';
import Heading from '../components/Heading.vue';
import {Action} from 'vuex-class';
import PasswordStrengthIndicator from '../components/PasswordStrengthIndicator.vue';
import {passwordStrengthCopy} from '@/helpers/validate-password';

@Component({
  components: {
    Password,
    ErrorGroup,
    Heading,
    PasswordStrengthIndicator
  },
})
export default class ChangePassword extends Vue {
  passwordStrengthCopy = passwordStrengthCopy;
  protected oldPassword: string = '';
  protected newPassword: string = '';
  protected isValidPassword: boolean = false;

  @Action('changePassword') protected changePasswordAction: any;

  protected handleSubmit() {
    this.changePasswordAction({
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
    });
  }

  @Watch('newPassword')
  private onModelChanged(value: string, oldValue: string) {
    this.isValidPassword = validatePassword(value);
  }
}
const validatePassword = (value: string): boolean => {
  return !!(value && hasMinChar(value) && hasNumber(value) && hasSpecialChar(value) && hasUpperCase(value) && hasLowerCase(value));
};
const hasMinChar = (value: string): boolean => value.length >= 8;
const hasNumber = (value: string): boolean => /\d/.test(value);
const hasSpecialChar = (value: string): boolean => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value);
const hasUpperCase = (value: string): boolean => /[A-Z]/.test(value);
const hasLowerCase = (value: string): boolean => /[a-z]/.test(value);
